const DocumentsActionTypes = {
    FETCH_DOCUMENTS_START: "FETCH_DOCUMENTS_START",
    FETCH_DOCUMENTS_SUCCESS: "FETCH_DOCUMENTS_SUCCESS",
    FETCH_DOCUMENTS_FAILURE: "FETCH_DOCUMENTS_FAILURE",
};

export default DocumentsActionTypes;
